import React, { Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Button from '../../../blocks/button/Button';
import FormSubmitAgreement from '../../../blocks/form-blocks/FormSubmitAgreement';
import { downloadPartners } from '../../actions';
import './style.css';

import InputField from '../../../blocks/inputField/InputField';
import { newEmailHandler }from '../../../validators/form-validators';
import { postSponsor } from '../../../actions/google-form-action';
import { clearFields } from '../../../actions/field-action';
import { GOOGLE_FORM_PENDING_FIELD_NAME_EMAIL } from '../../../actions/google-form-action';


class Organization extends Component {
  handleFormSubmit(type, event) {
    event.preventDefault();
    let validateSuccess = true;
    for (const key of Object.keys(this.refs)) {
      if (!this.refs[key].onValidate() && key.indexOf(type) > -1) {
        validateSuccess = false;
      }
    }
    if (validateSuccess) {
      let formData = new FormData(event.target);
      this.props.postSponsor(formData);
      for (const key of Object.keys(this.refs)) {
        if (key.indexOf(type) > -1) {
          this.refs[key].clearField();
        }
      }
    }
  }

  _generateOrgSection = () => {
    return this.props.viewList.map(partners => {
      let registration = !this.props.sponsorRegisterSuccess ?
        (
          <form
            className='sponsor-form'
            onSubmit={this.handleFormSubmit.bind(this, 'sponsor')}
            disabled={this.props.sponsorDataSending}
          >
            <div className='sponsor-form__field'>
              <InputField
                name={GOOGLE_FORM_PENDING_FIELD_NAME_EMAIL}
                tabIndex={1}
                onValidate={newEmailHandler}
                ref='sponsorEmail'
                placeholder={'Оставьте свой Email'}
              />
            </div>
            <Button
              styleClasses={['sponsor-form__submit-btn']}

            >
              Хотите стать спонсором?
            </Button>
            <FormSubmitAgreement/>
          </form>
        ) :
        (
          <div className='sponsor-form_success'>Спасибо за регистрацию!</div>
        );

      if (partners.partnerType === 'При поддержке') {
        return (
          <div key={partners.partnerType}>
            <div className='organization__title'>{partners.partnerType}</div>
            <div className='organization__companies'>{partners.partnerViews.map(company => (
              <a key={`${partners.partnerType}_${company.company.url}`}
                 target='_blank'
                 className='organization__company'
                 href={company.company.url}>
                <img className='organization__picture' src={company.pictureUrl} alt={company.name}/>
              </a>
            ))}
              <div className='organization__text'>Министерства экономики Омской области</div>
            </div>
          </div>
        )
      } else {
        return (
          <div key={partners.partnerType}>
            <div className='organization__title'>{partners.partnerType}</div>
            <div className='organization__companies'>{partners.partnerViews.map(company => (
              <a key={`${partners.partnerType}_${company.company.url}`}
                 target='_blank'
                 className='organization__company'
                 href={company.company.url}>
                <img className='organization__picture' src={company.pictureUrl} alt={company.name}/>
              </a>
            ))}
            </div>
            {partners.partnerType === 'Спонсоры' ?
              (registration) : null
            }
        </div>)
      }
  })};

  componentWillMount() {
    this.props.downloadPartners();
  }

  render() {
    const orgSection = this._generateOrgSection();
    return (<div className='organization'>
      {orgSection}
    </div>);
  }
}

const mapStateToProps = (state) => ({
  viewList: state.organization.viewList,
  sponsorDataSending: state.googleFormReducer.sponsorDataSending,
  sponsorRegisterSuccess: state.googleFormReducer.sponsorRegisterSuccess
});

const mapDispatchToProps = (dispatch) => ({
  downloadPartners: bindActionCreators(downloadPartners, dispatch),
  postSponsor: bindActionCreators(postSponsor, dispatch),
  clearFields: bindActionCreators(clearFields, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Organization);



// WEBPACK FOOTER //
// ./src/layout-page/blocks/organization/Organization.js